import {AxiosResponse} from 'axios';
import {enqueueSnackbar} from 'notistack';

import {
  API_BASE_URL,
  SUCCESS_CHANGE,
  ERROR,
  TOKEN_EXPIRED,
  IMAGE_QUERY_INVALID_INPUT,
  IMAGE_QUERY_ACCESS_DENIED,
  IMAGE_QUERY_NOT_FOUND,
  IMAGE_QUERY_CREATE_SUCCESS,
} from '../../constants';
import {
  ImageQueryMetadataResponseDto,
  ImageQueryRequestDto,
  ImageQueryResponseDto,
} from '../../models';
import {get, post, del, put} from '../api';

export function getUserImageQueries(
  token: string,
): Promise<AxiosResponse<ImageQueryMetadataResponseDto[]>> {
  return get(`${API_BASE_URL}/imageQuery/user`, {
    headers: {Authorization: `Bearer ${token}`},
    responseType: 'json',
  });
}

export function getImageQueryById(
  token: string,
  id: number,
): Promise<AxiosResponse<ImageQueryResponseDto>> {
  return get(`${API_BASE_URL}/imageQuery/query/${id}`, {
    headers: {Authorization: `Bearer ${token}`},
    responseType: 'json',
  });
}

export function updateImageQuery(
  token: string,
  id: number,
  data: ImageQueryRequestDto,
  onUpdateSuccess: () => void,
) {
  put(`${API_BASE_URL}/imageQuery/${id}`, {
    data,
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    responseType: 'json',
  })
    .then(_res => {
      enqueueSnackbar(SUCCESS_CHANGE, {variant: 'success'});
      onUpdateSuccess();
    })
    .catch(err => {
      switch (err?.response?.status) {
        case 400:
          enqueueSnackbar(IMAGE_QUERY_INVALID_INPUT, {variant: 'warning'});
          break;
        case 401:
          enqueueSnackbar(TOKEN_EXPIRED, {variant: 'error'});
          break;
        case 403:
          enqueueSnackbar(IMAGE_QUERY_ACCESS_DENIED, {variant: 'error'});
          break;
        case 404:
          enqueueSnackbar(IMAGE_QUERY_NOT_FOUND, {variant: 'warning'});
          break;
        default:
          enqueueSnackbar(ERROR, {variant: 'error'});
      }
    });
}

export function createImageQuery(
  token: string,
  data: ImageQueryRequestDto,
  onCreateSuccess: (id: number) => void,
) {
  post(`${API_BASE_URL}/imageQuery`, {
    data: data,
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    responseType: 'json',
  })
    .then(_res => {
      enqueueSnackbar(IMAGE_QUERY_CREATE_SUCCESS, {variant: 'success'});
      onCreateSuccess(_res.data as number);
    })
    .catch(err => {
      switch (err?.response?.status) {
        case 400:
          enqueueSnackbar(IMAGE_QUERY_INVALID_INPUT, {variant: 'warning'});
          break;
        case 401:
          enqueueSnackbar(TOKEN_EXPIRED, {variant: 'error'});
          break;
        default:
          enqueueSnackbar(ERROR, {variant: 'error'});
      }
    });
}

export function deleteImageQuery(
  token: string,
  id: number,
  onDeleteSuccess: () => void,
) {
  del(`${API_BASE_URL}/imageQuery/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    responseType: 'json',
  })
    .then(_res => {
      enqueueSnackbar(SUCCESS_CHANGE, {variant: 'success'});
      onDeleteSuccess();
    })
    .catch(err => {
      switch (err?.response?.status) {
        case 400:
          enqueueSnackbar(IMAGE_QUERY_INVALID_INPUT, {variant: 'warning'});
          break;
        case 401:
          enqueueSnackbar(TOKEN_EXPIRED, {variant: 'error'});
          break;
        case 403:
          enqueueSnackbar(IMAGE_QUERY_ACCESS_DENIED, {variant: 'error'});
          break;
        case 404:
          enqueueSnackbar(IMAGE_QUERY_NOT_FOUND, {variant: 'warning'});
          break;
        default:
          enqueueSnackbar(ERROR, {variant: 'error'});
      }
    });
}
